import React from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FunnelCustomFieldProps } from "components/form-funnel/types";
import PositionMultiSelect from "./PositionMultiSelect";

/**
 * The positions picker as a FormFunnel `custom` field (hiring questionnaire
 * step_1 and contract registration). The form keeps `positionIds`; the
 * backend derives positionLT/EN from them. A record saved before the
 * catalogue existed may still carry only the old free text — shown as a hint
 * so the editor knows what to pick.
 */
export default function PositionsFunnelField({
  value,
  onChange,
  label,
  required,
  error,
  readOnly,
  data,
}: FunnelCustomFieldProps) {
  const { companyId } = useParams<{ companyId: string }>();
  const { t } = useTranslation();
  const ids: string[] = Array.isArray(value) ? value : [];
  const legacyText = !ids.length && typeof data?.positionLT === "string" ? data.positionLT.trim() : "";
  if (!companyId) return null;
  return (
    <div>
      <PositionMultiSelect
        companyId={companyId}
        value={ids}
        onChange={onChange}
        label={label}
        required={required}
        error={error}
        disabled={readOnly}
      />
      {legacyText && (
        <p className="mt-1 text-xs text-amber-700">
          {t("positions_legacy_text_hint", { text: legacyText })}
        </p>
      )}
    </div>
  );
}
